/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：569
 */

module.exports = {
  flexSc: "DataWatch_flexSc__7ctNY",
  wrapper: "DataWatch_wrapper__1qka4",
  header: "DataWatch_header__3BN6n",
  toast: "DataWatch_toast__dGHBx",
  title: "DataWatch_title__1BlqL",
  closeBtn: "DataWatch_closeBtn__2pyXr",
  content: "DataWatch_content___ZFJ9",
  shadowContent: "DataWatch_shadowContent__3NI1P",
  help: "DataWatch_help__2R_FM"
}
